export default __webpack_public_path__ + "static/media/img_muslinTwoBunnyEarsBib_yg_p.5e812f75.jpg";